import React, { FunctionComponent } from 'react';
import { ChoiceBlock } from './ChoiceBlock';
import { Offers } from "@/models/scope/productSheet/offer/Offers";
import { SOLD_BY_MKP } from "@/utils/constants";

interface Props {
    offerList: Offers;
    setPriceIncludeVAT: (includeVAT: boolean) => void;
    priceIncludeVAT: boolean;
    isPei: boolean;
    setLayerType: (layerType: string) => void;
    productId: string;
    endDateRI: string;
    soldBy: string;
    setShowCloseLayerButton: (status: boolean) => void;
}

export const ChoiceBox: FunctionComponent<Props> = ({ offerList, isPei, setLayerType,setPriceIncludeVAT,
                                                        priceIncludeVAT, soldBy, productId, setShowCloseLayerButton, endDateRI }) => {
    let itemsToRender = [...offerList.items];
    if (soldBy === SOLD_BY_MKP) {
        itemsToRender.splice(offerList.winningOfferIndex, 1); // delete first element if context is 'MKP'
    }
    return (
        <div className='choiceBox'>
            {itemsToRender.map((item) => (
                item.offerId !== 0 && <ChoiceBlock
                    key={item.offerId}
                    isPei={isPei}
                    endDateRI={endDateRI}
                    setLayerType={setLayerType}
                    soldBy={soldBy}
                    offer={item} productId={productId}
                    priceIncludeVAT={priceIncludeVAT}
                    setPriceIncludeVAT={setPriceIncludeVAT}
                    setShowCloseLayerButton={setShowCloseLayerButton}
                    offersData={offerList}/>
            ))}
        </div>
    );
};